import { createRouter, createWebHistory } from 'vue-router'
import { trackRouter } from 'vue-gtag-next'
import Home from '../views/Home.vue'
import Inquiry from '../views/Inquiry.vue'
import Releases from '../views/Releases.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/inquiry',
    name: 'Inquiry',
    component: Inquiry
  },
  {
    path: '/releases',
    name: 'Releases',
    component: Releases
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth', top: 72 }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

trackRouter(router)

export default router
